import { getTracker } from '@moal/api'
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  TimeSeriesScale,
  Title,
  Tooltip
} from 'chart.js'
import 'chartjs-adapter-moment'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { PRODUCT_CODE } from '../../../../utils/ENV'
import Moaltip from '../../../Utilities/Tooltip/'
import DateRangePicker from '../DateRangePicker'
import styles from '../Stats.module.css'
import { getDateRangeLabels } from '../utils'

ChartJS.register(
  TimeScale,
  TimeSeriesScale,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
)

const UniqueUsersPerDay = () => {
  const [views, setViews] = useState([])
  const [labels, setLabels] = useState([])
  const [data, setData] = useState(null)
  const [startDate, setStartDate] = useState(
    moment().subtract(5, 'days').toDate()
  )
  const [endDate, setEndDate] = useState(moment().toDate())
  const [scaleType, setScaleType] = useState('timeseries')

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top'
      },
      tooltip: {
        titleFont: {
          size: 18
        },
        bodyFont: {
          size: 24
        },
        padding: 12
      }
    },
    scales: {
      x: {
        type: scaleType,
        time: {
          unit: 'day'
        }
      },
      y: {
        ticks: {
          stepSize: 20
        }
      }
    }
  }

  useEffect(() => {
    loadViews()
    handleLabels()
  }, [startDate, endDate])

  useEffect(() => {
    handleData()
  }, [views])

  const loadViews = async () => {
    const response = await getTracker({
      token: localStorage.getItem('authToken'),
      itemNumber: PRODUCT_CODE,
      startDate: moment(startDate).toISOString(),
      endDate: moment(endDate).toISOString()
    })

    if (response && response.status === 200) {
      setViews(response.data)
    }
  }

  const handleLabels = () => {
    const dateLabels = getDateRangeLabels(startDate, endDate)
    setLabels(dateLabels)
  }

  const handleData = () => {
    setData({
      labels,
      datasets: [
        {
          label: 'Max',
          data: views.map((each) => ({
            x: moment(each.createdAt).utc().format('YYYY-MM-DD'),
            y: Math.round(each.users.length)
          })),
          backgroundColor: '#355070',
          pointStyle: false
        }
      ]
    })
  }

  if (labels.length <= 0 || data === null) {
    return (
      <div className={styles.wrapper}>
        <div className="flex items-center justify-center my-auto">
          <p className="animate-pulse">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <header className="flex items-center gap-2">
        <h2>Unique Sign Ins Per Day</h2>
        <Moaltip>
          This chart shows the daily maximum user count. Each bar represents the
          number of users recorded on that day. Hover for details.
        </Moaltip>
      </header>
      <Bar options={options} data={data} className="p-2" />
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        scaleType={scaleType}
        setScaleType={setScaleType}
      />
    </div>
  )
}

export default UniqueUsersPerDay
